module.exports = __webpack_public_path__ + "img/goal03_over.3bd3c8b8.png";